import { useCallback, useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useSearcher } from 'components/modules/Insurance/hooks/useSearcher';
import * as InsuranceCalculationActions from 'store/insuranceCalculation';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';
import * as UserSelectors from 'store/user/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './BankSearcher.constants';

export const useBankSearcherPresenter = () => {
  const dispatch = useDispatch();

  const banks = useSelector(
    InsuranceCalculationSelectors.selectField(InsuranceCalculationConstants.FIELDS.INSURANCE_BANKS)
  );
  const disabled = useSelector(
    InsuranceCalculationSelectors.selectField(InsuranceCalculationConstants.FIELDS.BANKS_FETCH)
  );
  const { id: error } = useSelector(InsuranceCalculationSelectors.selectNestedErrors(NAME)) ?? {};
  const { id: value } = useSelector(InsuranceCalculationSelectors.selectSelectedBank) ?? {};
  const { id: dealerId } = useSelector(UserSelectors.getDealer);

  const { disabled: pageRestrict } = useDisabledFields();

  const data = useMemo(() => {
    return (banks ?? []).reduce((acc, brand) => {
      const { value: title, ...rest } = brand ?? {};

      if (typeof title === 'string') {
        acc.push({ ...rest, title });
      }

      return acc;
    }, []);
  }, [banks]);

  const presenter = useSearcher({ data });

  const onChange = useCallback(({ [NAME]: bank }) => {
    dispatch(InsuranceCalculationActions.insuranceSetErrors({ [NAME]: undefined }));
    dispatch(InsuranceCalculationActions.insuranceSetSelectedBank(bank));
  }, []);

  useEffect(() => {
    if (!dealerId) {
      return;
    }

    dispatch(InsuranceCalculationActions.insuranceGetBanksList({ dealerId }));
  }, [dealerId]);

  useEffect(() => {
    dispatch(InsuranceCalculationActions.insuranceSetBankFetch(true));
  }, []);

  return { ...presenter, disabled: disabled || pageRestrict, error, onChange, value };
};
